import { LocalImage } from '@akin-home/images';

export const fetchFileBlob = async (file: LocalImage) => {
  const response = await fetch(file.path);
  return await response.blob();
};
